"use strict";

var _Object$keys3 = require("@babel/runtime-corejs3/core-js-stable/object/keys");

var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");

var _filterInstanceProperty2 = require("@babel/runtime-corejs3/core-js-stable/instance/filter");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");

var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TEMPLATE = exports.DIRECTIONS = exports.TYPES = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/toConsumableArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _splice = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/splice"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));

var _values = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/values"));

var _assign = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/assign"));

var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));

var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));

var _indexOf = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/index-of"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

function ownKeys(object, enumerableOnly) { var keys = _Object$keys3(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = _filterInstanceProperty2(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { Object.defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

function reOrderArray(data, index, direction) {
  var to = direction === "UP" ? index - 1 : index + 1;
  if (direction === "UP" && to < 0) return data;
  if (direction === "DOWN" && to >= data.length) return data;
  var f = (0, _splice.default)(data).call(data, index, 1)[0];
  (0, _splice.default)(data).call(data, to, 0, f);
  return data;
}

function deleteFromArray(arr, i) {
  (0, _splice.default)(arr).call(arr, i, 1);
  return arr;
}

var Reducer = function Reducer(state, action) {
  var _Object$keys, _payload$index, _context, _context2, _context3;

  var type = action.type,
      payload = action.payload; // TYPES.ADD_QUESTION

  var index = (_Object$keys = (0, _keys.default)(state === null || state === void 0 ? void 0 : state.properties)) === null || _Object$keys === void 0 ? void 0 : _Object$keys.length; // TYPES.MOVE_QUESTION

  var direction = payload.direction,
      i = payload.index;
  var props = (0, _values.default)(state === null || state === void 0 ? void 0 : state.properties);
  var to = direction === "UP" ? i - 1 : i + 1; // TYPES.MARK_QUESTION_REQUIRED

  var ri = (_payload$index = payload.index) === null || _payload$index === void 0 ? void 0 : _payload$index.toString();
  var requiredArray = state.required; // TYPES.UPDATE_RADIO_BUTTON

  var rid = payload.index;
  var rkey = payload.key; // Common

  var reRenderId = Math.random().toString(36).substring(2, 15);

  switch (type) {
    case TYPES.QUESTIONNAIRE_TITLE:
      return _objectSpread(_objectSpread({}, state), {}, {
        title: payload
      });

    case TYPES.QUESTIONNAIRE_DESCRIPTION:
      return _objectSpread(_objectSpread({}, state), {}, {
        description: payload
      });

    case TYPES.ADD_QUESTION:
      return _objectSpread(_objectSpread({}, state), {}, {
        properties: _objectSpread(_objectSpread({}, state.properties), {}, (0, _defineProperty2.default)({}, index, payload))
      });

    case TYPES.UPDATE_QUESTION_TITLE:
      return _objectSpread(_objectSpread({}, state), {}, {
        properties: _objectSpread(_objectSpread({}, state.properties), {}, (0, _defineProperty2.default)({}, payload.index, _objectSpread(_objectSpread({}, state.properties[payload.index]), {}, {
          title: payload.title
        })))
      });

    case TYPES.MOVE_QUESTION:
      if (direction === "UP" && to < 0) return state;
      if (direction === "DOWN" && to >= props.length) return state;
      var f = (0, _splice.default)(props).call(props, i, 1)[0];
      (0, _splice.default)(props).call(props, to, 0, f);
      return _objectSpread(_objectSpread({}, state), {}, {
        properties: props
      });

    case TYPES.DELETE:
      return _objectSpread(_objectSpread({}, state), {}, {
        properties: (0, _assign.default)({}, (0, _filter.default)(_context = (0, _values.default)(state.properties)).call(_context, function (_, k) {
          return k !== payload;
        }))
      });

    case TYPES.MARK_QUESTION_REQUIRED:
      if ((0, _includes.default)(requiredArray).call(requiredArray, ri)) {
        var _i = (0, _indexOf.default)(requiredArray).call(requiredArray, ri);

        (0, _splice.default)(requiredArray).call(requiredArray, _i, 1);
      } else {
        requiredArray.push(ri);
      }

      return _objectSpread(_objectSpread({}, state), {}, {
        required: requiredArray
      });

    case TYPES.ADD_RADIO_BUTTON:
      state.properties[payload].enum.push("");
      return _objectSpread(_objectSpread({}, state), {}, {
        properties: _objectSpread(_objectSpread({}, state.properties), {}, (0, _defineProperty2.default)({}, payload, _objectSpread(_objectSpread({}, state.properties[payload]), {}, {
          enum: state.properties[payload].enum,
          reRenderId: reRenderId
        })))
      });

    case TYPES.UPDATE_RADIO_BUTTON:
      return _objectSpread(_objectSpread({}, state), {}, {
        properties: _objectSpread(_objectSpread({}, state.properties), {}, (0, _defineProperty2.default)({}, rid, _objectSpread(_objectSpread({}, state.properties[rid]), {}, {
          enum: (0, _toConsumableArray2.default)((0, _map.default)(_context2 = state.properties[rid].enum).call(_context2, function (v, i) {
            return i === rkey ? payload.value : v;
          }))
        })))
      });

    case TYPES.ADD_CHECKBBOX_BUTTON:
      state.properties[payload].items.enum.push("");
      return _objectSpread(_objectSpread({}, state), {}, {
        properties: _objectSpread(_objectSpread({}, state.properties), {}, (0, _defineProperty2.default)({}, payload, _objectSpread(_objectSpread({}, state.properties[payload]), {}, {
          items: _objectSpread(_objectSpread({}, state.properties[payload].items), {}, {
            enum: state.properties[payload].items.enum
          }),
          reRenderId: reRenderId
        })))
      });

    case TYPES.UPDATE_CHECKBOX_BUTTON:
      return _objectSpread(_objectSpread({}, state), {}, {
        properties: _objectSpread(_objectSpread({}, state.properties), {}, (0, _defineProperty2.default)({}, payload.index, _objectSpread(_objectSpread({}, state.properties[payload.index]), {}, {
          items: _objectSpread(_objectSpread({}, state.properties.items), {}, {
            enum: (0, _toConsumableArray2.default)((0, _map.default)(_context3 = state.properties[payload.index].items.enum).call(_context3, function (v, i) {
              return i === payload.key ? payload.value : v;
            }))
          })
        })))
      });

    case TYPES.UPDATE_RADIO_BUTTON_ORDER:
      return _objectSpread(_objectSpread({}, state), {}, {
        properties: _objectSpread(_objectSpread({}, state.properties), {}, (0, _defineProperty2.default)({}, payload.index, _objectSpread(_objectSpread({}, state.properties[payload.index]), {}, {
          enum: reOrderArray(state.properties[payload.index].enum, payload.key, payload.direction),
          reRenderId: reRenderId
        })))
      });

    case TYPES.UPDATE_CHECKBOX_BUTTON_ORDER:
      return _objectSpread(_objectSpread({}, state), {}, {
        properties: _objectSpread(_objectSpread({}, state.properties), {}, (0, _defineProperty2.default)({}, payload.index, _objectSpread(_objectSpread({}, state.properties[payload.index]), {}, {
          items: _objectSpread(_objectSpread({}, state.properties.items), {}, {
            enum: reOrderArray(state.properties[payload.index].items.enum, payload.key, payload.direction)
          }),
          reRenderId: reRenderId
        })))
      });

    case TYPES.DELETE_RADIO_BUTTON:
      return _objectSpread(_objectSpread({}, state), {}, {
        properties: _objectSpread(_objectSpread({}, state.properties), {}, (0, _defineProperty2.default)({}, payload.index, _objectSpread(_objectSpread({}, state.properties[payload.index]), {}, {
          enum: deleteFromArray(state.properties[payload.index].enum, payload.index),
          reRenderId: reRenderId
        })))
      });

    case TYPES.DELETE_CHECKBOX_BUTTON:
      return _objectSpread(_objectSpread({}, state), {}, {
        properties: _objectSpread(_objectSpread({}, state.properties), {}, (0, _defineProperty2.default)({}, payload.index, _objectSpread(_objectSpread({}, state.properties[payload.index]), {}, {
          items: {
            enum: deleteFromArray(state.properties[payload.index].items.enum, payload.key)
          },
          reRenderId: reRenderId
        })))
      });

    default:
      return state;
  }
};

var TYPES = {
  QUESTIONNAIRE_TITLE: "QUESTIONNAIRE_TITLE",
  QUESTIONNAIRE_DESCRIPTION: "QUESTIONNAIRE_DESCRIPTION",
  ADD_QUESTION: "ADD_QUESTION",
  UPDATE_QUESTION_TITLE: "UPDATE_QUESTION_TITLE",
  MOVE_QUESTION: "MOVE_QUESTION",
  DELETE: "DELETE",
  MARK_QUESTION_REQUIRED: "MARK_QUESTION_REQUIRED",
  ADD_CHECKBBOX_BUTTON: "ADD_CHECKBBOX_BUTTON",
  ADD_RADIO_BUTTON: "ADD_RADIO_BBUTTON",
  UPDATE_RADIO_BUTTON: "UPDATE_RADIO_BUTTON",
  UPDATE_CHECKBOX_BUTTON: "UPDATE_CHECKBOX_BUTTON",
  UPDATE_RADIO_BUTTON_ORDER: "UPDATE_RADIO_BUTTON_ORDER",
  UPDATE_CHECKBOX_BUTTON_ORDER: "UPDATE_CHECKBOX_BUTTON_ORDER",
  DELETE_RADIO_BUTTON: "DELETE_RADIO_BUTTON",
  DELETE_CHECKBOX_BUTTON: "DELETE_CHECKBOX_BUTTON"
};
exports.TYPES = TYPES;
var DIRECTIONS = {
  UP: "UP",
  DOWN: "DOWN"
};
/**
 * DEV_NOTE: 
 *  radio buttons do not work with strings
 *  so for new radio buttons are disabled
 */

exports.DIRECTIONS = DIRECTIONS;
var TEMPLATE = {
  // RADIO: {
  //   "type": "number",
  //   "title": "",
  //   "enum": [""]
  // },
  CHECKBOX: {
    "type": "array",
    "title": "",
    "items": {
      "type": "string",
      "enum": [""]
    },
    "uniqueItems": true
  },
  OPEN_ENDED: {
    "type": "string",
    "title": ""
  }
};
exports.TEMPLATE = TEMPLATE;
var _default = Reducer;
exports.default = _default;